import React from 'react'
import { Inbox } from 'lucide-react'
import { cn } from '../../lib/utils'
import { BOOKINGS_CONTENT_GUTTER } from '../../pages/MyBookings/components/bookingsLayout'

const AccountEmptyState = ({
  icon: Icon = Inbox,
  title,
  description,
  className
}) => (
  <div
    className={cn(
      'account-page-transition flex flex-col items-center justify-center py-16 text-center',
      BOOKINGS_CONTENT_GUTTER,
      className
    )}
  >
    <div className="mb-4 flex size-12 items-center justify-center rounded-full bg-foreground/10">
      <Icon
        className="size-6 text-muted-foreground"
        strokeWidth={1.75}
        aria-hidden
      />
    </div>
    <p className="m-0 text-base font-semibold text-foreground">{title}</p>
    {description ? (
      <p className="mt-1 mb-0 max-w-[280px] text-sm leading-5 text-secondary-foreground">
        {description}
      </p>
    ) : null}
  </div>
)

export default AccountEmptyState
